import React from 'react';
import { useNavigation } from '@react-navigation/native';

export const useBagNavigation = () => {
  const navigation = useNavigation();

  // This just opens the bag screen on the modal stack.
  const handleOpenBag = React.useCallback(() => {
    navigation.navigate('Modal', { screen: 'Bag' });
  }, [navigation]);

  // This will go back on the parent (dismiss the modal stack),
  // It will go back in the modal stack if needed.
  const handleCloseBag = React.useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.getParent()?.goBack();
    }
  }, [navigation]);

  return {
    handleOpenBag,
    handleCloseBag,
  };
};
